// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__COl2n","icone":"Loader_icone__xoz5V"};